import { clearSamplingAggregate } from '../utils/productionSamplingAggregateStorage'

// v2.1 finding #60 (WSL-08, 2026-07-01): idempotent bootstrap cleanup that
// removes the retired `production:samplingAggregate:v1` localStorage sidecar
// per tenant. Called once from `ensureOfflineReady`. Safe to run on:
//   - devices that never held sampling data (delete-of-absent-key is a no-op)
//   - devices with legacy WSL-04 sidecar data (server WeightSampleLog is the
//     authoritative store now, and the visible mean is refreshed from the
//     daily rollup on the next successful `syncWeightSampleLogsForContext`
//     — see WSL-06)
//   - restricted localStorage contexts (Safari private / iframes with no
//     storage grant): storage helpers already swallow SecurityError, but the
//     extra try/catch guarantees bootstrap can never be blocked by this
//     one-shot cleanup.
export const clearRetiredSamplingSidecar = (): void => {
  try {
    clearSamplingAggregate()
  } catch {
    // Bootstrap must not throw. If clearing fails the residual key is
    // harmless — no code path reads it anymore (see storage module header).
  }
}
